import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { MediaBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { objectFit } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/objectFit";
import { objectPosition } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/objectPosition";
import { opacity } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/opacity";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  ContentProp,
  DesignProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Video",
  nameI18n: "builder_ui.block_type.video",
  version: 1,
  category: [MediaBlock],
  props: {
    videoUpload: {
      name: "Video Upload",
      nameI18n: "builder_ui.prop_type.video",
      category: [ContentProp],
      prop: "other",
      type: "circle-video-upload",
      defaultValue: {
        source: "upload",
        signed_id: "",
        html: "",
        hasCustomCoverImage: false,
        customCoverImage: {
          signed_id: "",
        },
        isVideoMuted: false,
        isVideoLooped: false,
        hasAltText: false,
        videoAltText: "",
      },
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        objectFit: {
          ...objectFit,
          defaultValue: defaultStyles.objectFit,
        },
        objectPosition: {
          ...objectPosition,
          defaultValue: defaultStyles.objectPosition,
        },
        opacity: {
          ...opacity,
          defaultValue: defaultStyles.opacity,
        },
        borderRadius: {
          ...borderRadius,
          defaultValue: defaultStyles.borderRadius,
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
        sizing: {
          ...sizing,
          defaultValue: defaultStyles.sizing,
          category: [DesignProp, SizingProp],
        },
      },
    },
  },
};
